var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 9.763,
    height: 9.763,
    viewBox: "0 0 9.763 9.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.776,5.017l3.8-3.8A.632.632,0,0,0,8.683.321l-3.8,3.8L1.08.321a.632.632,0,0,0-.894.894l3.8,3.8-3.8,3.8a.632.632,0,1,0,.894.894l3.8-3.8,3.8,3.8a.632.632,0,0,0,.894-.894Zm0,0",
    transform: "translate(0 -0.136)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.dba06eb5.svg";
export { ForwardRef as ReactComponent };